<template>
  <span>
    <h1 class="center-align dash-header">Lineage Independence Trust Program</h1>

    <notifications-list :notifications="notifications"></notifications-list>
  </span>
</template>

<script>
import NotificationsList from "@/components/manager/NotificationsList"

export default {
  components: {
    NotificationsList
  },
  computed: {
    notifications() {
      return this.$store.getters["notifications/getNotifications"]
    }
  },
  created() {
    this.$store.dispatch("notifications/loadNotifications")
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/title";

.dash-header {
  color: $very-dark-grey;
  text-transform: uppercase;
}

.center-align {
  display: flex;
  justify-content: center;
}
</style>
